import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AnalyticsMessagesData, AnalyticsTemplatesResponse } from "../models/analytics-messages.model";

@Injectable({ providedIn: 'root' })
export class InsightsService {

  constructor(private http: HttpClient) { }

  getInsightsMessages(channelId: string, params: AnalyticsMessagesData): Observable<any> {
    const baseURL = `/insights/conversations`;
    const url = `${baseURL}/${channelId}`;
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        httpParams = httpParams.set(key, typeof value === 'object' ? JSON.stringify(value) : value as string);
      });
    }

    return this.http.get(url, { params: httpParams });
  }

  getInsightsTemplates(channelId: string, params: AnalyticsTemplatesResponse): Observable<any> {
    const baseURL = `/insights/templates`;

    const url = `${baseURL}/${channelId}`;

    let httpParams = new HttpParams();

    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        httpParams = httpParams.set(key, typeof value === 'object' ? JSON.stringify(value) : value as string);
      });
    }

    return this.http.get(url, { params: httpParams });
  }
}
